export const range = (start: number, end: number): number[] => [...Array(end - start + 1).keys()].map((v) => v + start);
